<template>
  <FormHeading :h="4">
    <span class="flex items-center gap-5">
      <strong>
        <AppIcon icon="mdi:account" size="large" class="icon" start />
        {{ $tt('applicant') }} #{{ index + 1 }}
      </strong>
      <span class="name">
        {{ name }}
      </span>
    </span>
    <AppBtn
      v-if="collapsable"
      v-tooltip:top="$tt('collapse')"
      :disabled="collapsed"
      icon="mdi:unfold-less-horizontal"
      size="small"
      borderless
      @click="$emit('collapse')"
    />
  </FormHeading>
</template>

<script setup lang="ts">
defineEmits(['collapse']);

defineProps<{
  index: number;
  name: string;
  collapsable: boolean;
  collapsed: boolean;
}>();
</script>

<style lang="scss" scoped>
h4 {
  display: flex;
  justify-content: space-between;

  .icon {
    display: inline-block;
  }
  .name {
    text-transform: uppercase;
  }
}
@media (max-width: 850px) {
  h4 {
    span {
      display: inline;
    }
    strong {
      display: block;
    }
  }
}
</style>